import React from 'react'
import Home from './pages/Home'
import About from './pages/About'
import Navbar from './components/Navbar'
import ChatBot from './components/ChatBot'
import { Route, Routes } from 'react-router-dom'
import Videos from './pages/Videos'
import Upload from './pages/Upload'
import Footer from './components/Footer'
import VideoInterFace from './pages/VideoInterFace'

const App = () => {
  return (
    <div>
      <div className='bg-gray-600'>
          <Navbar/>
          <ChatBot/>
          <Routes>
              <Route path='/' element ={<Home/>} />
              <Route path='/videos' element ={<Videos/>} />
              <Route path='/upload' element ={<Upload/>} />
              <Route path='/about' element ={<About/>} />
              <Route path='/video/:id' element ={<VideoInterFace/>} />
          </Routes>
        
      </div>
      <Footer/>
    </div>
  )
}

export default App
